import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  title = 'SciCommsPLanningNavigator';
  
  constructor(private authService: AuthService) {}
  
  ngOnInit(): void {
    // Check authentication status when app initializes
    this.authService.checkAuthStatus().subscribe();
  }
}
